export default function MainPage({ children }: { children: React.ReactNode }) {
  return <main>{children}</main>;
}
